import React, { useState, useEffect } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const Loading = () => {
    const [dots, setDots] = useState(''); // Estado para manejar los puntos suspensivos
    const spinnerStyle = {
        animation: 'spin 0.5s linear infinite',
    };

    // Actualiza los puntos suspensivos en un ciclo
    useEffect(() => {
        const interval = setInterval(() => {
            setDots((prevDots) => (prevDots.length < 3 ? prevDots + '.' : ''));
        }, 500); // Cambia cada 500ms

        return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente
    }, []);

    return (
        <div className="w-full h-full fixed inset-0 bg-black bg-opacity-75 z-50 flex flex-col items-center justify-center">
            {/* Definir la animación dentro del componente */}
            <style>
                {`
                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
                `}
            </style>
            {/* Spinner de carga */}
            <AiOutlineLoading3Quarters
                className="text-rose-500 text-6xl mb-4"
                style={spinnerStyle}
            />
            {/* Texto de carga con puntos dinámicos */}
            <div className="text-white text-2xl font-pixel">
                Loading<span style={{ display: 'inline-block', width: '1ch' }}>{dots}</span>
            </div>
        </div>
    );
};

export default Loading;
